/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForTenableNessus extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForTenableNessus");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForTenableNessus.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForTenableNessus>): ServiceAccountCredentialsForTenableNessus {
        let obj = Object.assign(new ServiceAccountCredentialsForTenableNessus(), model);
        ServiceAccountCredentialsForTenableNessus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForTenableNessus>): ServiceAccountCredentialsForTenableNessus {
        if (!model) return null;
        return ServiceAccountCredentialsForTenableNessus.newInstance(<ServiceAccountCredentialsForTenableNessus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForTenableNessus) {
        if (!obj) return;

        models.ServiceAccountCredentialsForTenableNessus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForTenableNessus): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForTenableNessus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Key Id. This is a required field.
     */
    accesskey: string;

    /**
     * Secret Access Key Id. This is a required field.
     */
    secretkey: string;

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

}
